import { useMemo, useState } from "react";
import { Form, Input } from "rsuite";
import { Button } from "../../components/button.component";
import { ApiAuth } from "../../core/apis/auth";
import { showSuccessToast } from "../../components/toast.component";

export const ChangePasswordForm = ({ expanded }: { expanded?: boolean }) => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const isDisabled = useMemo(
    () =>
      !(
        newPassword === confirmPassword &&
        newPassword.length > 5 &&
        confirmPassword.length > 5
      ),
    [confirmPassword, newPassword]
  );

  const handleSubmit = async () => {
    if (isDisabled) return;
    setIsLoading(true);
    const changed = await ApiAuth.ChangePasswordApi({
      confirmPassword,
      newPassword,
    });
    if (changed) {
      setConfirmPassword("");
      setNewPassword("");
      showSuccessToast("Password changed successfully");
    }
    setIsLoading(false);
  };

  return (
    <div className="accordion-item m-3 border-0">
      <p className="accordion-header" id="headingThree">
        <button
          className="accordion-button p-3 px-4 rounded-pill shadow-none setting-header border border-green-200"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseThree"
          aria-expanded="false"
          aria-controls="collapseThree"
        >
          Change Password &nbsp;{" "}
          <small className="small-text">(Change your own password)</small>
        </button>
      </p>
      <div
        id="collapseThree"
        className={`accordion-collapse collapse ${expanded ? "show" : "hide"}`}
        aria-labelledby="headingThree"
        data-bs-parent="#accordionExample"
      >
        <div className="accordion-body border-bottom border-start border-end border-1 rounded setting-box">
          <div className="py-3 border-bottom">
            <Form>
              <Form.Group>
                <Form.ControlLabel>New Password</Form.ControlLabel>
                <Input
                  disabled={isLoading}
                  type="password"
                  value={newPassword}
                  onChange={(e: any) => setNewPassword(e)}
                />
              </Form.Group>
              <Form.Group className="mb-1">
                <Form.ControlLabel>Confirm New Password</Form.ControlLabel>
                <Input
                  disabled={isLoading}
                  type="password"
                  value={confirmPassword}
                  onChange={(e: any) => setConfirmPassword(e)}
                />
              </Form.Group>
              {newPassword !== confirmPassword && (
                <p className="text-red-300">Password did not match</p>
              )}
            </Form>
          </div>
          <div className="d-flex justify-content-center">
            <Button
              loading={isLoading}
              onClick={() => handleSubmit()}
              disabled={isDisabled}
              type="submit"
              className="px-5 mt-3 btn-green"
              name="Update"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
